import React, { InputHTMLAttributes, useEffect, useRef, useState } from "react";

import { useField } from "@unform/core";

import { Container, Input, InvalidMessage, Label, Required } from "./styles";

interface IInputStyledProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
}

const CreditCardInput = ({
  name,
  label,
  required,
  placeholder,
  ...rest
}: IInputStyledProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);

  const onPressEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code === "Enter") {
      e.preventDefault();
      e.isPropagationStopped();
    }
  };

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => {
        return ref.current.value.replace(/[^0-9]/g, "");
      },
      setValue: (ref, value) => {
        ref.current.value = value;
      },
      clearValue: (ref) => {
        ref.current.value = "";
      },
    });
  }, [fieldName, registerField]);

  return (
    <Container>
      {label && (
        <Label>
          {label}
          {required && <Required>*</Required>}
        </Label>
      )}

      <Input
        id={fieldName}
        error={!!error}
        inputRef={inputRef}
        onFocus={clearError}
        onKeyPress={onPressEnter}
        defaultValue={defaultValue}
        autoComplete="do-not-autofill"
        placeholder={placeholder || label}
        inputMode="numeric"
        {...rest}
      />

      {error && <InvalidMessage>{error}</InvalidMessage>}
    </Container>
  );
};

export default CreditCardInput;
